import React, { Component } from "react";

import Robot from "../../static/assets/img/mywishes-robot.png";
import NotFound404 from "../../static/assets/img/404.png";

import Layout from "../../shared/components/Layout";

import {
	StyledLogo,
	BackWrapper,
	Title,
	Description,
	CustomLink,
	SubDescription,
	TextWrapper
} from "../../shared/components/Error";
import { logPageView } from "../../shared/utils/GoogleAnalytics";
import {Button} from "antd";
import styled from "styled-components";

class NotFound extends Component {
	componentDidMount() {
		// logPageView();
	}
	render() {
		return (
			<Layout fixedHeight="100vh">
				<NotFoundWrapper>
					<img style={{maxWidth: '80%'}} src={NotFound404}/>
					<Button onClick={() => this.props.history.push("/")} type="primary" size="large">Visit your Dashboard</Button>

					{/*<TextWrapper>*/}
					{/*	<Title>404</Title>*/}
					{/*	<Description align="left">*/}
					{/*		This page does not exist! <br/>*/}
					{/*		This is totally our fault, not your own.*/}
					{/*	</Description>*/}
					{/*	<SubDescription align="left">*/}
					{/*		We are working hard behind the scenes so please come*/}
					{/*		back to this page soon. In the meantime please use*/}
					{/*		the navigation on the left-hand side or visit your*/}
					{/*		dashboard by{" "}*/}
					{/*		<CustomLink to="/">*/}
					{/*			<b>clicking here</b>*/}
					{/*		</CustomLink>*/}
					{/*		.*/}
					{/*	</SubDescription>*/}
					{/*</TextWrapper>*/}
				</NotFoundWrapper>
			</Layout>
		);
	}
}

const NotFoundWrapper = styled.div`
	position: relative;
	margin: 2rem auto 8rem auto;
	max-width: 760px;
	min-height: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 36px;
`

export default NotFound;
